import { BasicCalendar, type BasicCalendarProps } from '@/components/basicCalendar/BasicCalendar';

export { CountryCodes, Languages } from 'shared/util/calendar';

import styles from './StickyCalendar.module.css';

export const StickyCalendar = (props: BasicCalendarProps) => <BasicCalendar className={styles.stickyCalendar} {...props} />;
